export default __webpack_public_path__ + "static/media/ankrBNB.84d3d226.png";